<template>
    <div class="header">
        <header class="app-header app-header-dark" v-show="navbar">
            <nav class="navbar navbar-expand-md navbar-dark bg-primary py-md-0" aria-label="navigation">
              <router-link to="/" class="navbar-brand">
                <img src="/assets/logo-white.png" height="40" alt="">
              </router-link>
                <button class="hamburger hamburger-squeeze d-flex d-md-none" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                  <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                  </span>
                </button>
                <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
                  <ul class="navbar-nav mr-auto mt-2 mt-md-0" >
                    <menu-item :menu="data" v-for="(data, i) in menu" v-bind:key="i"></menu-item>
                  </ul>
                  <div class="top-bar-item px-0 d-none d-sm-flex">
                    <ul class="header-nav nav">
                      <li class="nav-item dropdown header-nav-dropdown" :class="{'has-notified':has_notified}">
                        <a class="nav-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="page=1;list_notification=[];openByClick=true;getNotification()">
                          <span class="oi" :class="envelop_class"></span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-rich dropdown-menu-right" id="dropdown-menu">
                          <div class="dropdown-arrow"></div>
                          <h6 class="dropdown-header stop-propagation">
                            <span>Messages</span>
                          </h6><!-- .dropdown-scroll -->
                          <div class="dropdown-scroll perfect-scrollbar" id="container-notification">
                            <!-- .dropdown-item -->
                            <a href="#" class="dropdown-item" :class="{'unread' : !item.is_read }" @click="openModal(item, $event)" v-for="(item, i) in list_notification" v-bind:key="i">
                              <div class="list-group-item-figure user-avatar" >
                                <div class="tile tile-circle" :class="getRandomBg()">{{getInitial(item.module_name)}}</div>
                              </div>
                              <div class="dropdown-item-body" >
                                <p class="subject" data-toggle="tooltip" data-original-title="abcd" data-placement="top"> {{item.module_name}} </p>
                                <p class="text text-truncate"> {{item.message}} </p><span class="date">{{formatTime(item.minutes)}}</span>
                              </div>
                            </a>
                            <a href="#" class="dropdown-item" v-show="showloading">
                              <div class="dropdown-item-body text-center py-4" >
                                <div class="spinner-border text-primary" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </a>
                          </div><!-- /.dropdown-scroll -->
                          <router-link to="/notifications" class="dropdown-footer">
                            All messages <em class="fas fa-fw fa-long-arrow-alt-right"></em>
                          </router-link>

                        </div><!-- /.dropdown-menu -->
                      </li>
                      <!-- /.nav-item -->
                      <!-- .nav-item -->
                      <li class="nav-item dropdown header-nav-dropdown">
                        <a class="nav-link" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="oi oi-grid-three-up"></span></a> <!-- .dropdown-menu -->
                        <div class="dropdown-menu dropdown-menu-rich dropdown-menu-right">
                          <div class="dropdown-arrow"></div><!-- .dropdown-sheets -->
                          <div class="dropdown-sheets">
                            <!-- .dropdown-sheet-item -->
                            <div class="dropdown-sheet-item">
                              <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-indigo"><em class="oi oi-people"></em></span> <span class="tile-peek">Teams</span></a>
                            </div><!-- /.dropdown-sheet-item -->
                            <!-- .dropdown-sheet-item -->
                            <div class="dropdown-sheet-item">
                              <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-teal"><em class="oi oi-fork"></em></span> <span class="tile-peek">Projects</span></a>
                            </div><!-- /.dropdown-sheet-item -->
                            <!-- .dropdown-sheet-item -->
                            <div class="dropdown-sheet-item">
                              <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-pink"><em class="fa fa-tasks"></em></span> <span class="tile-peek">Tasks</span></a>
                            </div><!-- /.dropdown-sheet-item -->
                            <!-- .dropdown-sheet-item -->
                            <div class="dropdown-sheet-item">
                              <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-yellow"><em class="oi oi-fire"></em></span> <span class="tile-peek">Feeds</span></a>
                            </div><!-- /.dropdown-sheet-item -->
                            <!-- .dropdown-sheet-item -->
                            <div class="dropdown-sheet-item">
                              <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-cyan"><em class="oi oi-document"></em></span> <span class="tile-peek">Files</span></a>
                            </div><!-- /.dropdown-sheet-item -->
                          </div><!-- .dropdown-sheets -->
                        </div><!-- .dropdown-menu -->
                      </li><!-- /.nav-item -->
                    </ul><!-- /.nav -->
                    <div class="dropdown d-flex mr-md-n3">
                        <button class="btn-account w-100" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="user-avatar user-avatar-md">
                            <img :src="this.$store.getters.photo_profile" alt="" v-if="this.$store.getters.photo_profile" >
                            <div class="tile tile-circle" style="display:block" :class="getRandomBg()" v-else>{{profile.initial}}</div>
                          </span>
                          <span class="account-summary"><span class="account-name">{{profile.name}}</span>
                          <span class="account-description">{{profile.dept_name}}</span></span></button> <!-- .dropdown-menu -->
                        <div class="dropdown-menu">
                          <div class="dropdown-arrow ml-3"></div>
                          <h6 class="dropdown-header d-none d-md-block d-lg-none"> {{ profile.name }} </h6>
                          <a class="dropdown-item" href="javascript:void(0);" @click="toProfile"><span class="dropdown-icon oi oi-person"></span> Profile</a>
                          <router-link to="/logout" class="dropdown-item">
                            <span class="dropdown-icon oi oi-account-logout"></span> Logout
                          </router-link>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="#">Help Center</a> <a class="dropdown-item" href="#">Ask Forum</a> <a class="dropdown-item" href="#">Keyboard Shortcuts</a>
                        </div><!-- /.dropdown-menu -->
                    </div><!-- /.btn-account -->
                  </div>
                </div>
            </nav>
        </header>
        <!-- /.app-header -->
        <!-- .app-header -->
        <header class="app-header app-header-dark" v-show="aside">
            <!-- .top-bar -->
            <div class="top-bar">
                <!-- .top-bar-brand -->
                <div class="top-bar-brand">
                    <a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="28" viewbox="0 0 351 100">
                        <defs>
                            <path id="a" d="M156.538 45.644v1.04a6.347 6.347 0 0 1-1.847 3.98L127.708 77.67a6.338 6.338 0 0 1-3.862 1.839h-1.272a6.34 6.34 0 0 1-3.862-1.839L91.728 50.664a6.353 6.353 0 0 1 0-9l9.11-9.117-2.136-2.138a3.171 3.171 0 0 0-4.498 0L80.711 43.913a3.177 3.177 0 0 0-.043 4.453l-.002.003.048.047 24.733 24.754-4.497 4.5a6.339 6.339 0 0 1-3.863 1.84h-1.27a6.337 6.337 0 0 1-3.863-1.84L64.971 50.665a6.353 6.353 0 0 1 0-9l26.983-27.008a6.336 6.336 0 0 1 4.498-1.869c1.626 0 3.252.622 4.498 1.87l26.986 27.006a6.353 6.353 0 0 1 0 9l-9.11 9.117 2.136 2.138a3.171 3.171 0 0 0 4.498 0l13.49-13.504a3.177 3.177 0 0 0 .046-4.453l.002-.002-.047-.048-24.737-24.754 4.498-4.5a6.344 6.344 0 0 1 8.996 0l26.983 27.006a6.347 6.347 0 0 1 1.847 3.98zm-46.707-4.095l-2.362 2.364a3.178 3.178 0 0 0 0 4.501l2.362 2.364 2.361-2.364a3.178 3.178 0 0 0 0-4.501l-2.361-2.364z"></path>
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                            <path fill="currentColor" fill-rule="nonzero" d="M39.252 80.385c-13.817 0-getInitial21.06-8.915-21.06-22.955V13.862H.81V.936h33.762V58.1c0 6.797 4.346 9.026 9.026 9.026 2.563 0 5.237-.446 8.58-1.783l3.677 12.034c-5.794 1.894-9.694 3.009-16.603 3.009zM164.213 99.55V23.78h13.372l1.225 5.571h.335c4.457-4.011 10.585-6.908 16.491-6.908 13.817 0 22.174 11.031 22.174 28.08 0 18.943-11.588 29.863-23.957 29.863-4.903 0-9.694-2.117-13.594-6.017h-.446l.78 9.025V99.55h-16.38zm25.852-32.537c6.128 0 10.92-4.903 10.92-16.268 0-9.917-3.232-14.932-10.14-14.932-3.566 0-6.797 1.56-10.252 5.126v22.397c3.12 2.674 6.686 3.677 9.472 3.677zm69.643 13.372c-17.272 0-30.643-10.586-30.643-28.972 0-18.163 13.928-28.971 28.748-28.971 17.049 0 26.075 11.477 26.075 26.52 0 3.008-.558 6.017-.78 7.354h-37.663c1.56 8.023 7.465 11.589 16.491 11.589 5.014 0 9.36-1.337 14.263-3.9l5.46 9.917c-6.351 4.011-14.597 6.463-21.951 6.463zm-1.338-45.463c-6.462 0-11.031 3.454-12.702 10.363h23.622c-.78-6.797-4.568-10.363-10.92-10.363zm44.238 44.126V23.779h13.371l1.337 12.034h.334c5.46-9.025 13.595-13.371 22.398-13.371 4.902 0 7.465.78 10.697 2.228l-3.343 13.706c-3.454-1.003-5.683-1.56-9.806-1.56-6.797 0-13.928 3.566-18.608 13.483v28.749h-16.38z"></path>
                            <use class="fill-warning" xlink:href="#a"></use>
                        </g>
                    </svg></a>
                </div><!-- /.top-bar-brand -->
                <!-- .top-bar-list -->
                <div class="top-bar-list">
                    <!-- .top-bar-item -->
                    <div class="top-bar-item px-2 d-md-none d-lg-none d-xl-none">
                        <!-- toggle menu -->
                        <button class="hamburger hamburger-squeeze" type="button" ref="navbarToggle" data-toggle="aside" aria-label="toggle menu"><span class="hamburger-box"><span class="hamburger-inner"></span></span></button> <!-- /toggle menu -->
                    </div><!-- /.top-bar-item -->
                    <!-- .top-bar-item -->
                    <div class="top-bar-item top-bar-item-full">
                        <!-- .top-bar-search -->
                        <form class="top-bar-search">
                            <!-- .input-group -->
                            <div class="input-group input-group-search dropdown">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><span class="oi oi-magnifying-glass"></span></span>
                                </div><input type="text" class="form-control" data-toggle="dropdown" aria-label="Search" placeholder="Search"> <!-- .dropdown-menu -->
                                <div class="dropdown-menu dropdown-menu-rich dropdown-menu-xl ml-n4">
                                    <div class="dropdown-arrow ml-3"></div><!-- .dropdown-scroll -->
                                    <div class="dropdown-scroll perfect-scrollbar h-auto" style="max-height: 360px">
                                        <!-- .list-group -->
                                        <div class="list-group list-group-flush list-group-reflow mb-2">
                                            <h6 class="list-group-header d-flex justify-content-between">
                                                <span>Shortcut</span>
                                            </h6><!-- .list-group-item -->
                                            <div class="list-group-item py-2">
                                                <a href="#" class="stretched-link"></a>
                                                <div class="tile tile-sm bg-muted">
                                                    <em class="fas fa-user-plus"></em>
                                                </div>
                                                <div class="ml-2"> Create user </div>
                                            </div><!-- /.list-group-item -->
                                            <!-- .list-group-item -->
                                            <div class="list-group-item py-2">
                                                <a href="#" class="stretched-link"></a>
                                                <div class="tile tile-sm bg-muted">
                                                    <em class="fas fa-dollar-sign"></em>
                                                </div>
                                                <div class="ml-2"> Create invoice </div>
                                            </div><!-- /.list-group-item -->
                                            <h6 class="list-group-header d-flex justify-content-between mt-2">
                                                <span>In projects</span> <a href="#" class="font-weight-normal">Show more</a>
                                            </h6><!-- .list-group-item -->
                                            <div class="list-group-item py-2">
                                                <a href="#" class="stretched-link"><span class="sr-only">Go to search result</span></a>
                                                <div class="user-avatar user-avatar-sm bg-muted">
                                                    <img src="assets/images/avatars/bootstrap.svg" alt="">
                                                </div>
                                                <div class="ml-2">
                                                    <div class="mb-n1"> Bootstrap </div><small class="text-muted">Just now</small>
                                                </div>
                                            </div><!-- /.list-group-item -->
                                            <!-- .list-group-item -->
                                            <div class="list-group-item py-2">
                                                <a href="#" class="stretched-link"><span class="sr-only">Go to search result</span></a>
                                                <div class="user-avatar user-avatar-sm bg-muted">
                                                    <img src="assets/images/avatars/slack.svg" alt="">
                                                </div>
                                                <div class="ml-2">
                                                    <div class="mb-n1"> Slack </div><small class="text-muted">Updated 25 minutes ago</small>
                                                </div>
                                            </div><!-- /.list-group-item -->
                                            <!-- /.list-group-item -->
                                            <h6 class="list-group-header d-flex justify-content-between mt-2">
                                                <span>Another section</span> <a href="#" class="font-weight-normal">Show more</a>
                                            </h6><!-- .list-group-item -->
                                            <div class="list-group-item py-2">
                                                <a href="#" class="stretched-link"><span class="sr-only">Go to search result</span></a>
                                                <div class="tile tile-sm bg-muted"> P </div>
                                                <div class="ml-2">
                                                    <div class="mb-n1"> Product name </div>
                                                </div>
                                            </div><!-- /.list-group-item -->
                                        </div><!-- /.list-group -->
                                    </div><!-- /.dropdown-scroll -->
                                    <a href="#" class="dropdown-footer">Show all results</a>
                                </div><!-- /.dropdown-menu -->
                            </div><!-- /.input-group -->
                        </form><!-- /.top-bar-search -->
                    </div><!-- /.top-bar-item -->
                    <!-- .top-bar-item -->
                    <div class="top-bar-item top-bar-item-right px-0 d-none d-sm-flex">
                        <!-- .nav -->
                        <ul class="header-nav nav">
                            <!-- .nav-item -->
                            <li class="nav-item dropdown header-nav-dropdown has-notified">
                                <a class="nav-link" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="oi oi-pulse"></span></a> <!-- .dropdown-menu -->
                                <div class="dropdown-menu dropdown-menu-rich dropdown-menu-right">
                                    <div class="dropdown-arrow"></div>
                                    <h6 class="dropdown-header stop-propagation">
                                        <span>Activities <span class="badge">(2)</span></span>
                                    </h6><!-- .dropdown-scroll -->
                                    <div class="dropdown-scroll perfect-scrollbar">
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item unread">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces15.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Jeffrey Wells created a schedule </p><span class="date">Just now</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item unread">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces16.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Anna Vargas logged a chat </p><span class="date">3 hours ago</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces17.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Sara Carr invited to Stilearn Admin </p><span class="date">5 hours ago</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces18.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Arthur Carroll updated a project </p><span class="date">1 day ago</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces19.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Hannah Romero created a task </p><span class="date">1 day ago</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces20.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Angela Peterson assign a task to you </p><span class="date">2 days ago</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                        <!-- .dropdown-item -->
                                        <a href="#" class="dropdown-item">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/uifaces21.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="text"> Shirley Mason and 3 others followed you </p><span class="date">2 days ago</span>
                                            </div>
                                        </a> <!-- /.dropdown-item -->
                                    </div><!-- /.dropdown-scroll -->
                                    <a href="user-activities.html" class="dropdown-footer">All activities <em class="fas fa-fw fa-long-arrow-alt-right"></em></a>
                                </div><!-- /.dropdown-menu -->
                            </li><!-- /.nav-item -->
                            <!-- .nav-item -->
                            <li class="nav-item dropdown header-nav-dropdown has-notified">
                                <a class="nav-link" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="oi oi-envelope-open"></span></a> <!-- .dropdown-menu -->
                                <div class="dropdown-menu dropdown-menu-rich dropdown-menu-right">
                                    <div class="dropdown-arrow"></div>
                                    <h6 class="dropdown-header stop-propagation">
                                        <span>Messages</span> <a href="#">Mark all as read</a>
                                    </h6><!-- .dropdown-scroll -->
                                    <div class="dropdown-scroll perfect-scrollbar">
                                        <a href="#" class="dropdown-item unread" v-for="(item, i) in list_notification" v-bind:key="i">
                                            <div class="user-avatar">
                                                <img src="assets/images/avatars/team1.jpg" alt="">
                                            </div>
                                            <div class="dropdown-item-body">
                                                <p class="subject"> {{item.module_name}} </p>
                                                <p class="text text-truncate"> {{item.message}} </p><span class="date">{{item.minutes}}</span>
                                            </div>
                                        </a>
                                    </div><!-- /.dropdown-scroll -->
                                    <a href="page-messages.html" class="dropdown-footer">All messages <em class="fas fa-fw fa-long-arrow-alt-right"></em></a>
                                </div><!-- /.dropdown-menu -->
                            </li><!-- /.nav-item -->
                            <!-- .nav-item -->
                            <li class="nav-item dropdown header-nav-dropdown">
                                <a class="nav-link" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="oi oi-grid-three-up"></span></a> <!-- .dropdown-menu -->
                                <div class="dropdown-menu dropdown-menu-rich dropdown-menu-right">
                                    <div class="dropdown-arrow"></div><!-- .dropdown-sheets -->
                                    <div class="dropdown-sheets">
                                        <!-- .dropdown-sheet-item -->
                                        <div class="dropdown-sheet-item">
                                            <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-indigo"><em class="oi oi-people"></em></span> <span class="tile-peek">Teams</span></a>
                                        </div><!-- /.dropdown-sheet-item -->
                                        <!-- .dropdown-sheet-item -->
                                        <div class="dropdown-sheet-item">
                                            <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-teal"><em class="oi oi-fork"></em></span> <span class="tile-peek">Projects</span></a>
                                        </div><!-- /.dropdown-sheet-item -->
                                        <!-- .dropdown-sheet-item -->
                                        <div class="dropdown-sheet-item">
                                            <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-pink"><em class="fa fa-tasks"></em></span> <span class="tile-peek">Tasks</span></a>
                                        </div><!-- /.dropdown-sheet-item -->
                                        <!-- .dropdown-sheet-item -->
                                        <div class="dropdown-sheet-item">
                                            <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-yellow"><em class="oi oi-fire"></em></span> <span class="tile-peek">Feeds</span></a>
                                        </div><!-- /.dropdown-sheet-item -->
                                        <!-- .dropdown-sheet-item -->
                                        <div class="dropdown-sheet-item">
                                            <a href="#" class="tile-wrapper"><span class="tile tile-lg bg-cyan"><em class="oi oi-document"></em></span> <span class="tile-peek">Files</span></a>
                                        </div><!-- /.dropdown-sheet-item -->
                                    </div><!-- .dropdown-sheets -->
                                </div><!-- .dropdown-menu -->
                            </li><!-- /.nav-item -->
                        </ul><!-- /.nav -->
                        <!-- .btn-account -->
                        <div class="dropdown d-flex">
                            <button class="btn-account d-none d-md-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <span class="user-avatar user-avatar-md">
                                <img :src="this.$store.getters.photo_profile" alt="" v-if="this.$store.getters.photo_profile">
                                <div class="tile tile-circle" style="display:block" :class="getRandomBg()" v-else>{{profile.initial}}</div>
                              </span>
                              <span class="account-summary pr-lg-4 d-none d-lg-block"><span class="account-name">{{ profile.name }}</span>
                              <span class="account-description">{{profile.dept_name}}</span></span></button> <!-- .dropdown-menu -->
                            <div class="dropdown-menu">
                              <div class="dropdown-arrow ml-3"></div>
                              <h6 class="dropdown-header d-none d-md-block d-lg-none"> {{ profile.name }} </h6>
                              <a class="dropdown-item" style="text-decoration: none"><span class="dropdown-icon oi oi-person"></span> Profile</a>
                              <router-link to="/logout" class="dropdown-item">
                                <span class="dropdown-icon oi oi-account-logout"></span> Logout
                              </router-link>
                                <div class="dropdown-divider"></div><a class="dropdown-item" href="#">Help Center</a> <a class="dropdown-item" href="#">Ask Forum</a> <a class="dropdown-item" href="#">Keyboard Shortcuts</a>
                            </div><!-- /.dropdown-menu -->
                        </div><!-- /.btn-account -->
                    </div><!-- /.top-bar-item -->
                </div><!-- /.top-bar-list -->
            </div><!-- /.top-bar -->
        </header><!-- /.app-header -->
        <!-- .app-aside -->
        <aside class="app-aside app-aside-expand-md app-aside-light" v-show="aside" >
            <!-- .aside-content -->
            <div class="aside-content">
                <!-- .aside-header -->
                <header class="aside-header d-block d-md-none">
                    <!-- .btn-account -->
                    <button class="btn-account" type="button" data-toggle="collapse" data-target="#dropdown-aside">
                      <span class="user-avatar user-avatar-lg">
                            <img :src="this.$store.getters.photo_profile" alt="" v-if="this.$store.getters.photo_profile">
                            <div class="tile tile-circle" style="display:block" :class="getRandomBg()" v-else>{{profile.initial}}</div>
                      </span>
                      <span class="account-icon"><span class="fa fa-caret-down fa-lg"></span></span> <span class="account-summary">
                      <span class="account-name">{{ profile.name }}</span>
                      <span class="account-description">{{ profile.dept_name }}</span></span>
                    </button> <!-- /.btn-account -->
                    <!-- .dropdown-aside -->
                    <div id="dropdown-aside" class="dropdown-aside collapse">
                        <!-- dropdown-items -->
                        <div class="pb-3">
                          <router-link to="employment-edit">
                            <a class="dropdown-item" >
                              <span class="dropdown-icon oi oi-person"></span> Profile
                            </a>
                          </router-link>

                          <a class="dropdown-item" href="#" @click="logout"><span class="dropdown-icon oi oi-account-logout"></span> Logout</a>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="#">Help Center</a>
                          <a class="dropdown-item" href="#">Ask Forum</a>
                          <a class="dropdown-item" href="#">Keyboard Shortcuts</a>
                        </div><!-- /dropdown-items -->
                    </div><!-- /.dropdown-aside -->
                </header><!-- /.aside-header -->
                <!-- .aside-menu -->
                <div class="aside-menu overflow-hidden">
                    <!-- .stacked-menu -->
                    <nav id="stacked-menu" class="stacked-menu" aria-label="navigation">
                        <!-- .menu -->
                        <ul class="menu">
                          <side-menu :menu="data" v-for="(data, i) in menu" v-bind:key="i" :first="true"></side-menu>
                        </ul><!-- /.menu -->
                    </nav><!-- /.stacked-menu -->
                </div><!-- /.aside-menu -->
                <!-- Skin changer -->
                <footer class="aside-footer border-top p-3">
                    <button class="btn btn-light btn-block text-primary" data-toggle="skin">Night mode <em class="fas fa-moon ml-1"></em></button>
                </footer><!-- /Skin changer -->
            </div><!-- /.aside-content -->
        </aside><!-- /.app-aside -->
      <travel-request-approval ref="travel-request" :data="item"></travel-request-approval>
      <cash-advance-approval ref="cash-advance-request" :data="item"></cash-advance-approval>
      <work-from-home-approval ref="work-from-home" :data="item"></work-from-home-approval>
      <compensatory-overtime-approval ref="compensatory-overtime" :data="item"></compensatory-overtime-approval>
      <compensatory-approval ref="compensatory" :data="item"></compensatory-approval>
      <staff-approval ref="staff" :data="item"></staff-approval>
      <overtime-approval ref="overtime" :data="item"></overtime-approval>
      <leave-request-approval ref="leave-request" :data="item"></leave-request-approval>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MenuItem from "./MenuItem";
import SideMenu from "./SideMenu";
import AxiosCall from "../../../libs/AxiosCall";
import {urlApi} from "../../../config/url-api";
import TravelRequestApproval from "../pages/travel-request/TravelRequestApproval";
import CashAdvanceApproval from "../pages/cash-advance/CashAdvanceApproval";
import WorkFromHomeApproval from "../pages/work-from-home/WorkFromHomeApproval";
import CompensatoryOvertimeApproval from "../pages/compensatory-overtime/CompensatoryOvertimeApproval";
import CompensatoryApproval from "../pages/compensatory/CompensatoryApproval";
import StaffApproval from "../pages/staff/StaffApproval";
import OvertimeApproval from "../pages/overtime/OvertimeApproval";
import LeaveRequestApproval from "../pages/leave-request/LeaveRequestApproval";

export default {
  name: "Header",
  components: {
    LeaveRequestApproval,
    OvertimeApproval,
    StaffApproval,
    CompensatoryApproval,
    CompensatoryOvertimeApproval,
    WorkFromHomeApproval, CashAdvanceApproval, TravelRequestApproval, SideMenu, MenuItem},
  data() {
    return {
      envelop_class:'oi-envelope-open',
      has_notified:false,
      activeNav:false,
      navbar: true,
      arrNotRead: [],
      openByClick:false,
      aside: false,
      profile: {
        name:"",
        dept_name:"",
        photo:"",
        initial:""
      },
      bg_color:['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray'],
      list_notification:[],
      item:null,
      loading:false,
      showloading:false,
      menu:this.$store.state.menus.filter(x=>x.is_show == 1 && (x.children == undefined || x.children.length > 0)),
      page:1,
      limit:5
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, {passive: true})
    }
  },
  mounted() {
    this.list_notification = []
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
    this.observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        const newValue = m.target.getAttribute(m.attributeName);
        this.$nextTick(() => {
          this.onClassChange(newValue, m.oldValue);
        });
      }
    });

    this.observer.observe(this.$refs.navbarToggle, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
    });
    let ini = this
    if (window.PerfectScrollbar && $('.perfect-scrollbar').length > 0) {
      let ps
      $('.perfect-scrollbar:not(".aside-menu")').each(function () {
        if(this.id === 'container-notification'){
          ps = new PerfectScrollbar(this, {
            suppressScrollX: true,
            wheelPropagation: false,
          })
          document.querySelector('#container-notification').addEventListener('ps-y-reach-end', () => {
            setTimeout(()=>{
              if(!ini.loading) ini.getNotification()
            }, 20)

            setTimeout(()=>{
              ps.update()
            }, 30)

          });
        }
      })
    }
  },
  computed: {
    ...mapGetters(['scrollbarHide']),
  },
  watch:{
    arrNotRead(arr){
      if(arr.length > 0){
        if(!this.openByClick){
          this.envelop_class = 'oi-envelope-closed';
          this.has_notified = true;
        }

      } else {
        this.envelop_class = 'oi-envelope-open';
        this.has_notified = false;
      }
    }
  },
  methods: {
    ...mapActions(['setScrollHidden', 'authLogout']),
    onResize() {
      if (screen.width <= 770) {
        this.navbar = false
        this.aside = true
      } else {
        let el = this.$el.parentNode.lastChild.classList.contains("show")
        if (el) this.clickMenu()
        this.navbar = true
        this.aside = false
      }
    },
    clickMenu() {
      this.$refs.navbarToggle.click()
    },
    onClassChange(classAttrValue) {
      const classList = classAttrValue.split(' ');
      this.setScrollHidden(false)
      if (classList.includes('active')) {
        this.setScrollHidden(true)
      }
    },
    toProfile(){
      this.$router.replace({path:"/employee-edit"})
    },
    logout(){

    },
    getNotification(){
      let payload = {
        page:this.page,
        limit:this.limit,
      }
      this.loading = true
      this.showloading = true
      AxiosCall.Get(payload, urlApi.notification.list).then(res=>{
        if(res.success){
          if(res.atributes.length > 0){
            this.page++;

            for (let data of res.atributes){
              this.list_notification.push(data)
              if(!data.is_read) {
                let idx = this.arrNotRead.findIndex(x=>x.id==data.id)
                if(idx == -1) this.arrNotRead.push(data)
              }
            }

            this.envelop_class = 'oi-envelope-open';
            this.loading=false

          }else{
            this.loading = true;
          }

        }else{
          this.loading=false
          this.$parent.errorMessage(res.message)
        }
        this.showloading = false
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    formatTime(minutes){
      if(minutes>60){
        let hours = minutes/60
        if(hours < 24){
          return `${Math.round(hours)} hours ago`
        }else {
          let days = hours/24
          return `${Math.round(days)} days ago`
        }

      }else{
        if(minutes < 1){
          return `a minutes ago`
        }
        return `${minutes} minutes ago`
      }
    },
    getInitial(val){
      let arrVal = val.split(" ")
      let initial = ``
      for(let data of arrVal){
        initial += data.substring(0,1)
      }
      return initial
    },
    getRandomBg(){
      let bg_color = ['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray']
      const random = Math.floor(Math.random() * bg_color.length);
      return bg_color[random]
    },
    openModal(item, evt){
      evt.preventDefault()

      this.item = item
      this.readMessage()
      if(item.module_path === 'time-recording'){
        this.$router.push({name:'TimeRecordingApproval', query:{id:btoa(item.master_id)}}).catch(()=>{})
      }else{
        this.$refs[item.module_path].$refs.modal.show()
      }
    },
    readMessage(){
      let payload = {
        id:this.item.id
      }

      if(!this.item.is_read){
        AxiosCall.Put(payload,urlApi.notification.read_message).then(res=>{
          if(res.success){
            if(this.$route.path === '/notifications') this.$root.$emit("getNotification")
            this.page =1
            this.getNotification()
            let idx = this.arrNotRead.findIndex(x=>x.id == this.item.id)

            if(idx !== -1){
              this.arrNotRead.splice(idx, 1)
            }
          }
        }).catch()
      }

    },
    getData(){
      this.getNotification()
    },
    getSize(obj){
        let size = 0, key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    },
    getItem(id, module){
      let payload = {
        master_id:id,
        module :module
      }
      AxiosCall.Get(payload, urlApi.notification.detail).then(res=>{
        if(res.success){
          this.item = res.atributes
          this.readMessage()
          if(module === "time-recording"){
            this.$router.push({name:"TimeRecordingApproval", query:{emp_id:btoa(this.item.from_emp_id), period:btoa(atob(this.$route.query.p).toString())}})
          }else{
            this.$refs[module].$refs.modal.show()
          }

        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(e)
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  },
  created() {
    this.list_notification = []
    this.getNotification()
    try {
      let profile = this.$store.getters.userProfile
      this.profile.name = profile.data.attributes.emp_name
      this.profile.dept_name = profile.data.attributes.emp_dept_name
      this.profile.photo = profile.data.attributes.emp_photo
      this.profile.initial = this.profile.name.match(/\b(\w)/g).join("");

    }catch (e){
      console.log(e)
    }

    this.$root.$on("updateNotification", ()=>{
      this.getNotification()
    })

    if(this.$route.query.i !==undefined && this.$route.query.m !== undefined){
      this.getItem(atob(this.$route.query.i), atob(this.$route.query.m))
    }
  },
}
</script>